// extracted by mini-css-extract-plugin
module.exports = {"logoProvinceWrapper":"list-of-provinces_logoProvinceWrapper__J9yIY"};